/**
 * Ryan O'Dowd
 * 2025-10-16
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Menu as PaperMenu,
} from 'react-native-paper';
import React from 'react';

const Menu = (props: React.ComponentProps<typeof PaperMenu>) => {
  return (
    <PaperMenu
      key={`${props.visible}`}// @TODO: hack for now: https://github.com/callstack/react-native-paper/issues/4807#issuecomment-3397805016
      {...props}
    >
      {props.children}
    </PaperMenu>
  );
};

Menu.displayName = 'Menu';
Menu.Item = PaperMenu.Item;
export default Menu;
